export default "__VITE_ASSET__e437bced__"